export default {
  "hero.badge": "Ressource indépendante • Mise à jour régulière • Multilingue",
  "hero.title": "USFans Spreadsheet — Trouvez des produits, comparez et achetez plus intelligemment",
  "hero.subtitle":
    "Explorez le Spreadsheet USFans, découvrez des produits par catégorie, comparez les informations disponibles, informez-vous sur le contrôle qualité, la livraison et les conseils d'achat, et prenez de meilleures décisions.",
  "hero.trust": "Axé sur la sécurité • Aperçus QC • Guides de livraison",

  "intro.title": "Qu'est-ce que le Spreadsheet USFans ?",
  "intro.p1":
    "Le Spreadsheet USFans est un catalogue de produits partagé qui aide à découvrir, parcourir et comparer des articles dans de nombreuses catégories — des chaussures et vêtements aux sacs et accessoires.",
  "intro.p2":
    "Au lieu de parcourir des listes interminables, vous pouvez accéder directement à une catégorie ci-dessous, consulter ce qui est disponible et suivre les liens pour en savoir plus sur le site principal.",

  "categories.title": "Parcourir les produits USFans par catégorie",
  "categories.subtitle":
    "Choisissez une catégorie pour explorer les trouvailles disponibles. Chaque lien ouvre la section correspondante sur le site principal USFans.",

  "how.title": "Comment fonctionne le Spreadsheet",
  "how.step1.title": "Choisissez une catégorie",
  "how.step1.text": "Sélectionnez une catégorie dans le menu déroulant ou les cartes ci-dessous.",
  "how.step2.title": "Comparez les trouvailles",
  "how.step2.text": "Consultez les informations produit disponibles et comparez ce qui correspond à vos besoins.",
  "how.step3.title": "Vérifiez QC et livraison",
  "how.step3.text": "Lisez nos notes sur le contrôle qualité et la livraison pour savoir à quoi vous attendre.",
  "how.step4.title": "Continuez vers le site principal",
  "how.step4.text": "Suivez le lien vers le site principal pour voir les détails et finaliser votre commande.",

  "guide.title": "Lisez notre guide complet",
  "guide.subtitle":
    "Nouveau sur le Spreadsheet USFans ? Notre guide détaillé et original vous explique son fonctionnement, ce qu'il faut vérifier et comment acheter en toute confiance.",
  "guide.read": "Lire le guide",

  "articles.title": "Derniers guides et articles",
  "articles.subtitle":
    "Découvrez nos guides originaux et détaillés sur le Spreadsheet USFans — QC, livraison, coupons et sécurité.",
  "articles.readMore": "Lire l'article",

  "faq.title": "Questions fréquentes",
  "faq.q1": "Qu'est-ce que le Spreadsheet USFans ?",
  "faq.a1":
    "C'est un catalogue de produits partagé qui organise les articles en catégories pour faciliter la navigation et la comparaison.",
  "faq.q2": "usfanslink.lol est-il affilié à USFans ?",
  "faq.a2":
    "Non. C'est une ressource d'information indépendante et non nécessairement affiliée à USFans.",
  "faq.q3": "Puis-je acheter directement sur ce site ?",
  "faq.a3":
    "Non. Ce site vous redirige vers le site principal USFans, où vous pouvez consulter les détails et finaliser votre achat.",
  "faq.q4": "Quelles langues sont disponibles ?",
  "faq.a4":
    "L'anglais, le français, l'espagnol et le polonais sont disponibles via le sélecteur de langue dans l'en-tête.",

  "cta.title": "Prêt à explorer le Spreadsheet ?",
  "cta.subtitle":
    "Accédez au Spreadsheet USFans, parcourez les produits par catégorie et comparez avant d'acheter.",

  "safety.title": "Note de sécurité",
  "safety.text":
    "Vérifiez toujours les détails du produit, consultez les photos QC lorsqu'elles sont disponibles et vérifiez les conditions de livraison avant tout achat. Ce site fournit uniquement des informations et ne vend pas directement de produits.",
};